import PayoutBankAccount from './PayoutBankAccount';

export default {
  PayoutBankAccount,
};
